import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import DOMPurify from 'dompurify';
import useDisclaimer from '../../../hooks/useDisclaimer';
import GetDisclaimer from '../../../selectors/getDisclaimer';
import {
    GET_ARCHISTAR_HAZARDS_DISCLAIMER_FAIL,
    getArchistarHazardsDisclaimer,
} from '../../../actions/clapi';
import Commons from '../../../helpers/Commons';

export const ArchistarHazardsDisclaimer = (props) => {
    const { archistarHazardsDisclaimer, propertyPlanningDetails, dispatch } = props;
    const displayArchistarHazardsDisclaimer = !!propertyPlanningDetails?.planningDetails;

    const action = useMemo(() =>
        !Commons.get(archistarHazardsDisclaimer, 'context.disclaimer') &&
        getArchistarHazardsDisclaimer('disclaimers', 'HazardrisksArchistarZoning_au'
        ), []);

    const disclaimer = useDisclaimer(archistarHazardsDisclaimer,
        action,
        dispatch,
    );

    const disclaimerText = Commons.get(disclaimer, 'context.disclaimer');
    return (
        disclaimer.context && displayArchistarHazardsDisclaimer &&
        <p className="archistar-hazards-disclaimer" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(disclaimerText) }} />
    )
};

const ConnectedArchistarHazardsDisclaimer = connect((state) => ({
    archistarHazardsDisclaimer: GetDisclaimer(state,
        GET_ARCHISTAR_HAZARDS_DISCLAIMER_FAIL,
        'archistarHazardsDisclaimer',
        'Unable to fetch archistar hazards disclaimer ({status})'
    ),
    propertyPlanningDetails: state.clapi.get('propertyPlanningDetails'),
}))(ArchistarHazardsDisclaimer);
ConnectedArchistarHazardsDisclaimer.displayName = 'ArchistarHazardsDisclaimer';

export default ConnectedArchistarHazardsDisclaimer;
